/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PlanListPaginationContainer_search$ref = any;
export type SearchType = "ADMITS" | "ATTENTION" | "BARRIER" | "DISCHARGE" | "ESCALATIONS" | "LOS_REVIEW" | "PATIENT" | "PROGRESSION" | "VARIANCE" | "VISIT" | "%future added value";
export type PlanListPaginationContainerQueryVariables = {|
  first?: ?number,
  after?: ?string,
  query?: ?string,
  type?: ?SearchType,
|};
export type PlanListPaginationContainerQueryResponse = {|
  +$fragmentRefs: PlanListPaginationContainer_search$ref
|};
export type PlanListPaginationContainerQuery = {|
  variables: PlanListPaginationContainerQueryVariables,
  response: PlanListPaginationContainerQueryResponse,
|};
*/


/*
query PlanListPaginationContainerQuery(
  $first: Int
  $after: String
  $query: String
  $type: SearchType
) {
  ...PlanListPaginationContainer_search_Fqyl5
}

fragment PlanListPaginationContainer_search_Fqyl5 on Query {
  viewer {
    beds(first: $first, after: $after, type: $type, query: $query) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
      edges {
        bed: node {
          id
          name
          exchangeName
          status
          department {
            id
            exchangeName
            name
            type
          }
          visit {
            id
            vector {
              id
              patientId
              encounterId
              predictionDate
              conditions {
                name
                riskBracket
                riskFactors {
                  id
                  type
                  description
                }
                recommendations {
                  id
                  rank
                  description
                  code
                  accepted
                }
              }
            }
            admissionTime
            admissionType
            admittingComplaint
            anticipatedDischargeTime
            anticipatedDischargeUpdatedBy {
              id
              userName
              firstName
              lastName
            }
            attendingPhysician {
              firstName
              id
              lastName
            }
            bedRequestStatus
            bedRequests {
              id
              bedRequestType
              bedRequestStatus
              updatedWhen
              bedExchangeName
            }
            currentDayOfStay
            decisionTime
            decisionTimeEditable
            decisionTimeUseMidnight
            dischargeVendor
            drgAttributes {
              id
              code
              level
              modifyTargetLos
              title
            }
            drgUpdatedBy {
              id
              firstName
              lastName
              userName
            }
            homeBedExchangeName
            insurancePlans {
              id
              planName
              priority
            }
            meta {
              id
              decisionDue
              dischargeToday
              plannedDischargeExceeded
              timeElapsedSinceAdmission
              tlosExceeded
            }
            patient {
              id
              age
              firstName
              gender
              lastName
              middleInitial
              mrn
              language {
                code
                defaultValue
              }
            }
            patientAlerts {
              id
              alertType
              value
            }
            patientProblem
            readmission
            readmissionRisk
            targetDischargeTime
            tlos
            visitNumber
            visitFacilityId
            visitStatus
            workingDischargeDisposition {
              code
              id
              value
              workingDischargeDispositionGroup
            }
            plan {
              id
              actions {
                __typename
                id
                text
                pinned
                status
                auditMeta {
                  updated
                }
              }
              appliedTemplates {
                id
                name
                description
                documentURL
                removed
              }
              barriers {
                __typename
                id
                name
                description
                pinned
                status
                escalation {
                  id
                }
                auditMeta {
                  updated
                }
                ownerMessageStatus
                ownerKnownUser {
                  id
                  emailReceiver
                  instantMessageReceiver
                }
              }
              careTeamMembers {
                id
                name
                role {
                  id
                  code
                  value
                }
                primary
              }
              meta {
                milestoneMeta {
                  overdue
                  onTime
                  completed
                }
              }
              milestones {
                __typename
                id
                actions {
                  __typename
                  id
                  pinned
                  text
                  auditMeta {
                    updated
                  }
                }
              }
              notes {
                __typename
                id
                text
                pinned
                auditMeta {
                  updated
                }
              }
              progressionIndicator
              toBeAdmitted
            }
            anticipatedTransferTime
            anticipatedDischargeTimeAutoPopulated
            anticipatedTransferTimeAutoPopulated
          }
          dischargedVisits {
            id
            admissionTime
            admissionType
            admittingComplaint
            anticipatedDischargeTime
            anticipatedDischargeUpdatedBy {
              id
              userName
              firstName
              lastName
            }
            attendingPhysician {
              firstName
              id
              lastName
            }
            bedRequestStatus
            bedRequests {
              id
              bedRequestType
              bedRequestStatus
              updatedWhen
              bedExchangeName
            }
            currentDayOfStay
            decisionTime
            decisionTimeEditable
            decisionTimeUseMidnight
            dischargeVendor
            drgAttributes {
              id
              code
              level
              title
            }
            drgUpdatedBy {
              id
              firstName
              lastName
              userName
            }
            homeBedExchangeName
            insurancePlans {
              id
              planName
              priority
            }
            meta {
              id
              decisionDue
              dischargeToday
              plannedDischargeExceeded
              timeElapsedSinceAdmission
              tlosExceeded
            }
            patient {
              id
              age
              firstName
              gender
              lastName
              middleInitial
              mrn
              language {
                code
                defaultValue
              }
            }
            patientAlerts {
              id
              alertType
              value
            }
            patientProblem
            readmission
            readmissionRisk
            targetDischargeTime
            tlos
            visitNumber
            visitFacilityId
            visitStatus
            workingDischargeDisposition {
              code
              id
              value
            }
            plan {
              id
              actions {
                __typename
                id
                text
                pinned
                status
                auditMeta {
                  updated
                }
              }
              appliedTemplates {
                id
                name
                description
                documentURL
                removed
              }
              barriers {
                __typename
                id
                name
                description
                pinned
                status
                escalation {
                  id
                }
                auditMeta {
                  updated
                }
              }
              careTeamMembers {
                id
                name
                role {
                  id
                  code
                  value
                }
                primary
              }
              meta {
                milestoneMeta {
                  overdue
                  onTime
                  completed
                }
              }
              milestones {
                __typename
                id
                actions {
                  id
                  pinned
                  text
                  auditMeta {
                    updated
                  }
                }
              }
              notes {
                __typename
                id
                text
                pinned
                auditMeta {
                  updated
                }
              }
              progressionIndicator
              toBeAdmitted
            }
          }
        }
        cursor
        node {
          __typename
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "admissionTime",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "admissionType",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "admittingComplaint",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedDischargeTime",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditUser",
  "kind": "LinkedField",
  "name": "anticipatedDischargeUpdatedBy",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonnelRole",
  "kind": "LinkedField",
  "name": "attendingPhysician",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v6/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bedRequestStatus",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "BedRequest",
  "kind": "LinkedField",
  "name": "bedRequests",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bedRequestType",
      "storageKey": null
    },
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedWhen",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bedExchangeName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentDayOfStay",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decisionTime",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decisionTimeEditable",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decisionTimeUseMidnight",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dischargeVendor",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "level",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditUser",
  "kind": "LinkedField",
  "name": "drgUpdatedBy",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "homeBedExchangeName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "InsurancePlan",
  "kind": "LinkedField",
  "name": "insurancePlans",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "VisitMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "decisionDue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dischargeToday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedDischargeExceeded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeElapsedSinceAdmission",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tlosExceeded",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Patient",
  "kind": "LinkedField",
  "name": "patient",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "age",
      "storageKey": null
    },
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gender",
      "storageKey": null
    },
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "middleInitial",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mrn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Language",
      "kind": "LinkedField",
      "name": "language",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "PatientAlert",
  "kind": "LinkedField",
  "name": "patientAlerts",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertType",
      "storageKey": null
    },
    (v36/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientProblem",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readmission",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readmissionRisk",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetDischargeTime",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tlos",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitNumber",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitFacilityId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitStatus",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditMeta",
  "kind": "LinkedField",
  "name": "auditMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updated",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "PlanAction",
  "kind": "LinkedField",
  "name": "actions",
  "plural": true,
  "selections": [
    (v46/*: any*/),
    (v6/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/),
    (v9/*: any*/),
    (v49/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateInfo",
  "kind": "LinkedField",
  "name": "appliedTemplates",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Escalation",
  "kind": "LinkedField",
  "name": "escalation",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "CareTeamMember",
  "kind": "LinkedField",
  "name": "careTeamMembers",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CodeTablePair",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v12/*: any*/),
        (v36/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primary",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "PlanMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MilestoneMeta",
      "kind": "LinkedField",
      "name": "milestoneMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overdue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "PlanNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v46/*: any*/),
    (v6/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/),
    (v49/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressionIndicator",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toBeAdmitted",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PlanListPaginationContainerQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "PlanListPaginationContainer_search"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "PlanListPaginationContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "BedConnection",
            "kind": "LinkedField",
            "name": "beds",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BedEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": "bed",
                    "args": null,
                    "concreteType": "Bed",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Department",
                        "kind": "LinkedField",
                        "name": "department",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v7/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Visit",
                        "kind": "LinkedField",
                        "name": "visit",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PatientVector",
                            "kind": "LinkedField",
                            "name": "vector",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "patientId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "encounterId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "predictionDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PatientCondition",
                                "kind": "LinkedField",
                                "name": "conditions",
                                "plural": true,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "riskBracket",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PatientRiskFactor",
                                    "kind": "LinkedField",
                                    "name": "riskFactors",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PatientRecommendation",
                                    "kind": "LinkedField",
                                    "name": "recommendations",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "rank",
                                        "storageKey": null
                                      },
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "accepted",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DrgAttributes",
                            "kind": "LinkedField",
                            "name": "drgAttributes",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v29/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "modifyTargetLos",
                                "storageKey": null
                              },
                              (v30/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WorkingDischargeDispositionDTO",
                            "kind": "LinkedField",
                            "name": "workingDischargeDisposition",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v6/*: any*/),
                              (v36/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "workingDischargeDispositionGroup",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Plan",
                            "kind": "LinkedField",
                            "name": "plan",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Barrier",
                                "kind": "LinkedField",
                                "name": "barriers",
                                "plural": true,
                                "selections": [
                                  (v46/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v11/*: any*/),
                                  (v48/*: any*/),
                                  (v9/*: any*/),
                                  (v52/*: any*/),
                                  (v49/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ownerMessageStatus",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "KnownUser",
                                    "kind": "LinkedField",
                                    "name": "ownerKnownUser",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emailReceiver",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "instantMessageReceiver",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v53/*: any*/),
                              (v54/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Milestone",
                                "kind": "LinkedField",
                                "name": "milestones",
                                "plural": true,
                                "selections": [
                                  (v46/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MilestoneAction",
                                    "kind": "LinkedField",
                                    "name": "actions",
                                    "plural": true,
                                    "selections": [
                                      (v46/*: any*/),
                                      (v6/*: any*/),
                                      (v48/*: any*/),
                                      (v47/*: any*/),
                                      (v49/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedTransferTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedDischargeTimeAutoPopulated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedTransferTimeAutoPopulated",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Visit",
                        "kind": "LinkedField",
                        "name": "dischargedVisits",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DrgAttributes",
                            "kind": "LinkedField",
                            "name": "drgAttributes",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WorkingDischargeDispositionDTO",
                            "kind": "LinkedField",
                            "name": "workingDischargeDisposition",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v6/*: any*/),
                              (v36/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Plan",
                            "kind": "LinkedField",
                            "name": "plan",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v50/*: any*/),
                              (v51/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Barrier",
                                "kind": "LinkedField",
                                "name": "barriers",
                                "plural": true,
                                "selections": [
                                  (v46/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v11/*: any*/),
                                  (v48/*: any*/),
                                  (v9/*: any*/),
                                  (v52/*: any*/),
                                  (v49/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v53/*: any*/),
                              (v54/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Milestone",
                                "kind": "LinkedField",
                                "name": "milestones",
                                "plural": true,
                                "selections": [
                                  (v46/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MilestoneAction",
                                    "kind": "LinkedField",
                                    "name": "actions",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v48/*: any*/),
                                      (v47/*: any*/),
                                      (v49/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Bed",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v46/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": [
              "type",
              "query"
            ],
            "handle": "connection",
            "key": "PlanListPaginationContainer_beds",
            "kind": "LinkedHandle",
            "name": "beds"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e627d88c6404b37e7f21f0df8da0488",
    "id": null,
    "metadata": {},
    "name": "PlanListPaginationContainerQuery",
    "operationKind": "query",
    "text": "query PlanListPaginationContainerQuery(\n  $first: Int\n  $after: String\n  $query: String\n  $type: SearchType\n) {\n  ...PlanListPaginationContainer_search_Fqyl5\n}\n\nfragment PlanListPaginationContainer_search_Fqyl5 on Query {\n  viewer {\n    beds(first: $first, after: $after, type: $type, query: $query) {\n      totalCount\n      pageInfo {\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        totalCount\n      }\n      edges {\n        bed: node {\n          id\n          name\n          exchangeName\n          status\n          department {\n            id\n            exchangeName\n            name\n            type\n          }\n          visit {\n            id\n            vector {\n              id\n              patientId\n              encounterId\n              predictionDate\n              conditions {\n                name\n                riskBracket\n                riskFactors {\n                  id\n                  type\n                  description\n                }\n                recommendations {\n                  id\n                  rank\n                  description\n                  code\n                  accepted\n                }\n              }\n            }\n            admissionTime\n            admissionType\n            admittingComplaint\n            anticipatedDischargeTime\n            anticipatedDischargeUpdatedBy {\n              id\n              userName\n              firstName\n              lastName\n            }\n            attendingPhysician {\n              firstName\n              id\n              lastName\n            }\n            bedRequestStatus\n            bedRequests {\n              id\n              bedRequestType\n              bedRequestStatus\n              updatedWhen\n              bedExchangeName\n            }\n            currentDayOfStay\n            decisionTime\n            decisionTimeEditable\n            decisionTimeUseMidnight\n            dischargeVendor\n            drgAttributes {\n              id\n              code\n              level\n              modifyTargetLos\n              title\n            }\n            drgUpdatedBy {\n              id\n              firstName\n              lastName\n              userName\n            }\n            homeBedExchangeName\n            insurancePlans {\n              id\n              planName\n              priority\n            }\n            meta {\n              id\n              decisionDue\n              dischargeToday\n              plannedDischargeExceeded\n              timeElapsedSinceAdmission\n              tlosExceeded\n            }\n            patient {\n              id\n              age\n              firstName\n              gender\n              lastName\n              middleInitial\n              mrn\n              language {\n                code\n                defaultValue\n              }\n            }\n            patientAlerts {\n              id\n              alertType\n              value\n            }\n            patientProblem\n            readmission\n            readmissionRisk\n            targetDischargeTime\n            tlos\n            visitNumber\n            visitFacilityId\n            visitStatus\n            workingDischargeDisposition {\n              code\n              id\n              value\n              workingDischargeDispositionGroup\n            }\n            plan {\n              id\n              actions {\n                __typename\n                id\n                text\n                pinned\n                status\n                auditMeta {\n                  updated\n                }\n              }\n              appliedTemplates {\n                id\n                name\n                description\n                documentURL\n                removed\n              }\n              barriers {\n                __typename\n                id\n                name\n                description\n                pinned\n                status\n                escalation {\n                  id\n                }\n                auditMeta {\n                  updated\n                }\n                ownerMessageStatus\n                ownerKnownUser {\n                  id\n                  emailReceiver\n                  instantMessageReceiver\n                }\n              }\n              careTeamMembers {\n                id\n                name\n                role {\n                  id\n                  code\n                  value\n                }\n                primary\n              }\n              meta {\n                milestoneMeta {\n                  overdue\n                  onTime\n                  completed\n                }\n              }\n              milestones {\n                __typename\n                id\n                actions {\n                  __typename\n                  id\n                  pinned\n                  text\n                  auditMeta {\n                    updated\n                  }\n                }\n              }\n              notes {\n                __typename\n                id\n                text\n                pinned\n                auditMeta {\n                  updated\n                }\n              }\n              progressionIndicator\n              toBeAdmitted\n            }\n            anticipatedTransferTime\n            anticipatedDischargeTimeAutoPopulated\n            anticipatedTransferTimeAutoPopulated\n          }\n          dischargedVisits {\n            id\n            admissionTime\n            admissionType\n            admittingComplaint\n            anticipatedDischargeTime\n            anticipatedDischargeUpdatedBy {\n              id\n              userName\n              firstName\n              lastName\n            }\n            attendingPhysician {\n              firstName\n              id\n              lastName\n            }\n            bedRequestStatus\n            bedRequests {\n              id\n              bedRequestType\n              bedRequestStatus\n              updatedWhen\n              bedExchangeName\n            }\n            currentDayOfStay\n            decisionTime\n            decisionTimeEditable\n            decisionTimeUseMidnight\n            dischargeVendor\n            drgAttributes {\n              id\n              code\n              level\n              title\n            }\n            drgUpdatedBy {\n              id\n              firstName\n              lastName\n              userName\n            }\n            homeBedExchangeName\n            insurancePlans {\n              id\n              planName\n              priority\n            }\n            meta {\n              id\n              decisionDue\n              dischargeToday\n              plannedDischargeExceeded\n              timeElapsedSinceAdmission\n              tlosExceeded\n            }\n            patient {\n              id\n              age\n              firstName\n              gender\n              lastName\n              middleInitial\n              mrn\n              language {\n                code\n                defaultValue\n              }\n            }\n            patientAlerts {\n              id\n              alertType\n              value\n            }\n            patientProblem\n            readmission\n            readmissionRisk\n            targetDischargeTime\n            tlos\n            visitNumber\n            visitFacilityId\n            visitStatus\n            workingDischargeDisposition {\n              code\n              id\n              value\n            }\n            plan {\n              id\n              actions {\n                __typename\n                id\n                text\n                pinned\n                status\n                auditMeta {\n                  updated\n                }\n              }\n              appliedTemplates {\n                id\n                name\n                description\n                documentURL\n                removed\n              }\n              barriers {\n                __typename\n                id\n                name\n                description\n                pinned\n                status\n                escalation {\n                  id\n                }\n                auditMeta {\n                  updated\n                }\n              }\n              careTeamMembers {\n                id\n                name\n                role {\n                  id\n                  code\n                  value\n                }\n                primary\n              }\n              meta {\n                milestoneMeta {\n                  overdue\n                  onTime\n                  completed\n                }\n              }\n              milestones {\n                __typename\n                id\n                actions {\n                  id\n                  pinned\n                  text\n                  auditMeta {\n                    updated\n                  }\n                }\n              }\n              notes {\n                __typename\n                id\n                text\n                pinned\n                auditMeta {\n                  updated\n                }\n              }\n              progressionIndicator\n              toBeAdmitted\n            }\n          }\n        }\n        cursor\n        node {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '291fce6b858caa79bc44dce554e69226';

module.exports = node;
